import React from "react";
import { Box, Container } from "@mui/material";
import "./Navigation.css";
import Dimond from "../../img/Dimond.svg";

const Navigation = () => {
  return (
    <Box id="home">
      <Box className="sticky py-0">
        <Container sx={{ flexGrow: 1 }}>
          <nav className="navbar navbar-expand-md navbar-dark">
            <a href="#home">
              <img style={{ width: "60px" }} src={Dimond} alt="Dimond icon" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbar">
              <ul className="navbar-nav flex-row flex-wrap ms-auto">
                <li className="nav-item col-6 col-md-auto">
                  <a
                    className="nav-link active"
                    aria-current="page"
                    href="#home"
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item col-6 col-md-auto">
                  <a className="nav-link" href="#about">
                    About
                  </a>
                </li>
                <li className="nav-item col-6 col-md-auto">
                  <a className="nav-link" href="#skill">
                    Skill
                  </a>
                </li>
                <li className="nav-item col-6 col-md-auto">
                  <a className="nav-link" href="#project">
                    Project
                  </a>
                </li>
                <li className="nav-item col-6 col-md-auto">
                  <a className="nav-link" href="#contact">
                    Contact
                  </a>
                </li>
                <li className="nav-item col-6 col-md-auto">
                  <button className="resume-button">
                    <a
                      className="nav-link"
                      rel="noreferrer"
                      target="_blank"
                      href="https://drive.google.com/file/d/1xMiWnwivJjSzciF-9n_z9CcFAQU_13sm/view?usp=sharing"
                    >
                      Resume
                    </a>
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </Container>
      </Box>
    </Box>
  );
};

export default Navigation;
